export default "__VITE_ASSET__b3db4170__"